module.exports = __webpack_public_path__ + "img/shengbidebao.b4d8588c.png";